import {
  LOAD_SUCCESS_LANGUES,
  LOAD_FAIL_LANGUES,
  SAVE_SUCCESS_LANGUES,
  SAVE_FAIL_LANGUES,
  UPDATE_SUCCESS_LANGUES,
  UPDATE_FAIL_LANGUES,
  DELETE_SUCCESS_LANGUES,
  DELETE_FAIL_LANGUES,
} from "../actions/langueAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_LANGUES:
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_LANGUES:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_LANGUES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_LANGUES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_LANGUES:
      const updatedListe = [];

      state.data.forEach((item) => {
        if (item.langue_id === action.payload.langue_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_LANGUES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_LANGUES:
      const filtered = state.data.filter((item) => {
        return item.langue_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_LANGUES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
